import styled from "styled-components"

export const Link = styled.a`
  height: ${({height = 56}) => height}px;
  display: inline-block;
`

export const Image = styled.img`
  height: 100%;
`